import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MessageList from './MessageList';
import UserInput from './UserInput';
import Header from './Header';
import { Scrollbars } from 'react-custom-scrollbars';
import { getCurrentUser } from './../../services/AuthService'


class ChatWindow extends Component {
  scrollbars = React.createRef();
  // state = {
  //   ntnted: false,
  // }
  constructor(props) {
    super(props);
    // this.props.isOpen = 'opened'
    this.state = {
    swidth: window.innerWidth,
    sheight: window.innerHeight
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    localStorage.setItem("scrollMount",false);
    localStorage.setItem("messagePageNumber",0);
  }

  onUserInputSubmit(message) {
    this.props.onUserInputSubmit(message);
  }

  onFilesSelected(filesList) {
    this.props.onFilesSelected(filesList);
  }

  componentDidMount() {
    // this.setState({mounted: true});
    localStorage.setItem("scrollMount",true);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    // this.refs.myscroll.addEventListener("scroll", () => {
    //   var scrollTop = document.getElementById('box').scrollTop;
    //   // console.log(scrollTop)
    //   if (scrollTop==0) {
    //     let currentPage = parseInt(localStorage.getItem("messagePageNumber"))+1;
    //     localStorage.setItem("messagePageNumber",currentPage);
    //     localStorage.setItem("scrollMount",false);
    //     this.fetchMoreData();
    //   }
    // });
    getCurrentUser()
    .then(response => {
      localStorage.setItem("UserProfile",JSON.stringify(response));
    }).catch(error => {
      this.setState({
        loading: false
      });  
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
    // alert(window.innerHeight)
    // alert(this.state.sheight)
  }

  componentDidUpdate() {
    // localStorage.getItem("scrollMount")==='true' && this.scrollbars.current.scrollToBottom();
    // this.refs.myscroll.scrollToBottom();
    // console.log(localStorage.getItem("messagePageNumber"));
    if(parseInt(localStorage.getItem("messagePageNumber"))=== 0){
          // var div = document.getElementById("box");
          // div.scrollTop = div.scrollHeight;
          this.scrollbars.current.scrollToBottom();
    }
    // else{
    //       var div = document.getElementById("box");
    //       div.scrollTop = div.scrollHeight/2;
    // }
  }
  handleScroll =(e) =>{
    e.preventDefault();
    // var scrollTop = document.getElementById('box').scrollTop;
    if(e.target.scrollTop === 0){
      // this.scrollbars.current.scrollTop(200);
      let currentPage = parseInt(localStorage.getItem("messagePageNumber"))+1;
      localStorage.setItem("messagePageNumber",currentPage);
      localStorage.setItem("scrollMount",false);
      this.props._onScrollLoadMessage();
    }
  }

    fetchMoreData = () => {
    let currentPage = parseInt(localStorage.getItem("messagePageNumber"))+1;
      localStorage.setItem("messagePageNumber",currentPage);
      // localStorage.setItem("scrollMount",false);
      this.props._onScrollLoadMessage();
  };

  render() {
    let messageList = this.props.messageList || [];
    let classList = [
      'sc-chat-window',
      // (this.props.isOpen ? 'opened' : 'closed')
      ('opened')
    ];
    return (
      <div className={classList.join(' ')}>
        <Header
          teamName={this.props.agentProfile.teamName}
          imageUrl={this.props.agentProfile.imageUrl}
          onClose={this.props.onClose}
        />
        

        
          {/* <Scrollbars autoHeight autoHeightMin={window.innerHeight < 1080 ? 550 : 850} autoHeightMax={window.innerHeight < 1080 ? 550 : 850} onScroll={this.handleScroll}  ref={this.scrollbars}> */}
          <Scrollbars autoHeight autoHeightMin={this.state.sheight-220} autoHeightMax={this.state.sheight-220} onScroll={this.handleScroll}  ref={this.scrollbars}>

          <MessageList
            messages={messageList}
            imageUrl={this.props.agentProfile.imageUrl}
          />

          </Scrollbars>
        <UserInput
          onSubmit={this.onUserInputSubmit.bind(this)}
          onFilesSelected={this.onFilesSelected.bind(this)}
          showEmoji={this.props.showEmoji}
        />
      </div>
    );
  }
}

ChatWindow.propTypes = {
  agentProfile: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onFilesSelected: PropTypes.func,
  onUserInputSubmit: PropTypes.func.isRequired,
  showEmoji: PropTypes.bool,
};

export default ChatWindow;
